<template>
  <div class="tipsPage">
    
    <div class="section1">

      <div class="hidden-sm-down">
        <img src="../assets/tips-section1.jpg"/>

        <p class="title">
          藥餌的殺滅效用
        </p>
        <p class="subTitle">
          了解威滅<sup>&reg;</sup> 藥餌如何有效針對害蟲巢穴
        </p>
      </div>

      <div class="hidden-md-up">
        <img src="../assets/tips-section1-m.jpg"/>
      </div>

    </div>

    <div class="section2">

      <div class="text">
        <div class="hidden-md-up">
          <p class="title">
            藥餌的殺滅效用
          </p>
          <p class="subTitle">
            了解威滅<sup>&reg;</sup> 藥餌如何有效針對害蟲巢穴
          </p>
          <img src="../assets/tips-section2.jpg"/>
        </div>

        <h1>殺蟲藥的指引</h1>

        <p class="text1">
          曱甴和螞蟻的出現主要由食物殘渣和水源所引致。一旦他們找到既有供應的時候，他們就會開始佔據並建立自己的巢穴。如果你的家居出現了曱甴和螞蟻的問題，這些害蟲很可能已經發現了穩定的食物和水源處。
        </p>
        <p class="text2">
          要有效消滅曱甴和螞蟻的唯一可靠方法，就是將它們由源頭鎖定。威滅<sup>&reg;</sup> 速效藥餌含有致命的高效殺蟲成份快倍隆。藥餌被包裝成食物的來源，成份配方混合了碳水化合物，所以對於曱甴和螞蟻而言，絕對是不可抗拒的美味混合物。
        </p>
        <p class="text2">
          一旦曱甴和螞蟻攝入藥餌，他們就會將其巢穴感染。根據天然習性: 螞蟻會將食物帶回巢穴分享，而曱甴會返回巢穴死亡、繼而被其他曱甴食用同伴屍體，進一步將殺蟲藥傳染到巢穴其他部分，結果就可以達致連環殺滅的功效。
        </p>
      </div>

      <img class="hidden-sm-down" src="../assets/tips-section2.jpg"/>

    </div>

    <div class="section2 b">

      <div class="img_wrapper"><img src="../assets/tips-section2bb.jpg"/></div>

      <div class="text">
        <h1>藥餌的殺滅效用</h1>

        <p class="text1">
          普遍的殺蟲噴霧與威滅® 速效藥餌功效有很大區別。 普遍的殺蟲噴霧只是短期控制害蟲，而威滅<sup>&reg;</sup> 速效藥餌的真正目標是長期控制害蟲的入侵。殺蟲噴霧只能殺滅肉眼看見到的害蟲，其如的害蟲會繼續於巢穴存活及繁殖，所以殺蟲噴霧僅能解一時之憂。假若巢穴仍然被置之不理，害蟲入侵的問題只會持續存在，日益惡化。
        </p>
      </div>

    </div>

    <contact></contact>
    <henkel-footer></henkel-footer>
  </div>
</template>

<script>
export default {
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../styles/_vars.sass"

.tipsPage
  padding-top: $topMenu-height

  .title
    font-size: 44px
    line-height: 35px

    @media only screen and (max-width: 1320px) and (min-width: 768px)
      font-size: 36px

  .subTitle
    font-size: 20px
    line-height: 25px

  .section1
    position: relative
    background-color: #08080b
    width: 100%
    overflow: auto

    img
      width: 100%

    p
      color: black
      position: absolute
      left: 64px
      left: 48px

      &.title
        bottom: 13%

        @media only screen and (min-width: 1920px)
          font-size: 48px
          bottom: 70px

        @media only screen and (max-width: 1320px) and (min-width: 768px)
          bottom: 36px

      &.subTitle
        bottom: 3%

        @media only screen and (min-width: 1920px)
          font-size: 24px
          bottom: 31px

        @media only screen and (max-width: 1320px) and (min-width: 768px)
          bottom: 8px

  .section2
    background-color: #d9d9d9
    padding-top: 30px
    padding-bottom: 100px
    padding-bottom: 0
    padding-right: 73px
    padding-left: 73px
    padding-right: 48px
    padding-left: 48px
    overflow: auto
    font-size: 14px

    @media only screen and (max-width: 768px)
      padding: 30px 30px 0 30px
    
    .text
      color: black
      width: 40%
      width: calc(55% - 36px)
      float: left

      @media only screen and (max-width: 768px)
        width: 100%
        float: none
      
      @media only screen and (min-width: 1920px)
        width: 50%

      .title
        font-size: 2.5em
        line-height: 30px
      
      .subTitle
        font-size: 1.2em
        margin-bottom: 5%
      
      .text1, .text2
        line-height: 25px
        font-size: 1.2em

      h1
        margin-bottom: 28px

        @media only screen and (max-width: 768px)
          margin-bottom: 18px

    img
      float: right
      width: 45%

      @media only screen and (max-width: 768px)
        width: 100%
        float: none
        margin-top: 0
        margin-bottom: 5%

      @media only screen and (min-width: 1920px)
        width: 70vh
        margin-top: 0

    &.b
      padding-bottom: 30px
      display: flex
      align-items: center

      @media only screen and (max-width: 768px)
        display: block
      
      .text
        float: right
        margin-left: 36px

      .img_wrapper
        width: 45%

        @media only screen and (max-width: 768px)
          width: 100%

      img
        float: left
        width: 100%

</style>



// WEBPACK FOOTER //
// PTipsInsecticideGuide.vue?550c1f1e